import { FC } from "react";

import { UpdatecampaignAccessButton } from "../../UpdatecampaignAccessButton";
import { CampaignAccessDataUser } from "../../../store";

interface CampaignAccessManagementActionsProps {
  campaignUUID: string;
  campaignName: string;
  users: CampaignAccessDataUser[];
}

export const CampaignAccessManagementActions: FC<CampaignAccessManagementActionsProps> =
  ({ campaignUUID, campaignName, users }) => {
    return (
      <UpdatecampaignAccessButton
        campaignUUID={campaignUUID}
        campaignName={campaignName}
        users={users}
      />
    );
  };
